import React, { useState } from 'react';
import * as S from './styles.ts';
import Tabs, { TTab } from '@template/components/Tabs';
import { SearchTab } from './SearchTab';
import Globe from '@template/icons/Globe.tsx';
import Phone from '@template/icons/Phone.tsx';

interface ICallRatesTabsProps {
  onSearch: (number: string) => void;
  loading: boolean;
}

export const CallRatesTabs = ({ onSearch, loading }: ICallRatesTabsProps) => {
  const tabs: TTab[] = [
    {
      key: 'local',
      label: {
        value: 'Local Call Costs',
        startContent: <Phone />,
      },
      content: (
        <SearchTab context='local' onSearch={onSearch} loading={loading} />
      ),
    },
    {
      key: 'international',
      label: {
        value: 'International Call Costs',
        startContent: <Globe />,
      },
      content: (
        <SearchTab
          context='international'
          onSearch={onSearch}
          loading={loading}
        />
      ),
    },
  ];

  const [tab, setTab] = useState(tabs[0].key);

  return (
    <S.CallRatesTabsContainer>
      <Tabs tabs={tabs} defaultSelected={tab} onTabChange={(t) => setTab(t)} />
    </S.CallRatesTabsContainer>
  );
};
